import { Component, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IModoLuminaria } from 'modelos/src';
import { AuxiliaresModule } from '../../../../../auxiliares/auxiliares.module';
import { HelperService } from '../../../../../auxiliares/servicios/helper.service';

@Component({
  standalone: true,
  imports: [AuxiliaresModule],
  selector: 'app-cambio-modo',
  templateUrl: './cambio-modo.component.html',
  styleUrl: './cambio-modo.component.scss',
})
export class CambioModoComponent implements OnInit {
  data = inject<{
    modoActual?: IModoLuminaria;
  }>(MAT_DIALOG_DATA);
  dialogRef = inject<MatDialogRef<CambioModoComponent>>(MatDialogRef);
  private helper = inject(HelperService);

  public loading = false;
  public formGroup: FormGroup;
  public modoLuminaria: IModoLuminaria[] = [
    'Astronómico',
    'Fotocélula',
    'Manual',
  ];

  private crearForm() {
    this.formGroup = new FormGroup({
      mode: new FormControl(
        this.data?.modoActual ?? 'Astronómico',
        Validators.required,
      ),
    });
  }

  public getModo(): IModoLuminaria {
    return this.formGroup.get('mode')?.value;
  }

  public async onSubmit() {
    this.loading = true;
    try {
      const modo = this.getModo();
      this.helper.notifSuccess('Modo cambiado correctamente');
      this.dialogRef.close(modo);
    } catch (error) {
      console.error(error);
      this.helper.notifError(error);
    }
    this.loading = false;
  }

  ngOnInit() {
    this.crearForm();
  }
}
